import * as React from 'react';

import { PollerDevTools } from './PollerDevTools';
import { useGlobalPolling } from './useGlobalPolling';

export function GlobalPoller() {
  useGlobalPolling();

  return (
    <>
      <PollerDevTools />
    </>
  );
}
